import {createTheme, ThemeOptions} from "@mui/material";

export const themeOptions: ThemeOptions = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#46ab3f',
      contrastText: 'rgba(255,255,255,0.87)',
    },
    secondary: {
      main: '#a43fab',
    },
  },
});
